import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';

/**
* A moment timezone pipe to support parsing based on time zone abbreviations
* covers all cases of offset variation due to daylight saving.
*
* Same API as DatePipe with additional timezone abbreviation support
* Official date pipe dropped support for abbreviations names from
Angular V5
*/

@Pipe({
  name: 'momentDate',
})
export class MomentDatePipe extends DatePipe implements PipeTransform {
    transform(value: Date|string|number): string|null;
    transform(value: null|undefined): null;
    transform(value: Date|string|number|null|undefined): string|null;
    // transform(value: Date|string|number|null|undefined): string|null {
    //     return super.transform(value, "yyyy-MM-dd HH:mm:ss");
    // }
    transform(
    value: string | Date,
    format: string = 'dd.MM.yyyy HH:mm',
    timezone: string = 'Europe/Bucharest'
  ): string|null {
    const timezoneOffset = moment(value).tz(timezone).format('Z');
    return super.transform(value, format, timezoneOffset);
  }
}
